class PbhTransparentHeader extends HTMLElement {
  constructor() {
    super();
    this.threshold = 20;
    this.onScroll = this.onScroll.bind(this);
  }

  connectedCallback() {
    this.headerSection = document.querySelector('.section-header');
    if (!this.headerSection) return;

    this.onScroll();
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const isPastThreshold = scrollTop > this.threshold;

    this.headerSection.classList.toggle('pbh-header-scrolled', isPastThreshold);
  }
}

if (!customElements.get('pbh-transparent-header')) {
  customElements.define('pbh-transparent-header', PbhTransparentHeader);
}
